const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const ContractWorkbench = () => import(/* webpackChunkName: "contractManage" */'@/components/pages/contractManage/Workbench');
const ContractCreatePage = () => import(/* webpackChunkName: "contractManage" */'@/components/pages/contractManage/ContractCreatePage');
const RelateAssets = () => import(/* webpackChunkName: "contractManage" */'@/components/pages/contractManage/RelateAssets');
const ContractWorkflowDetail = () => import(/* webpackChunkName: "contractManage" */'@/components/pages/contractManage/ContractWorkflowDetail');

export default [
  {
    path: '/contract-manage',
    name: 'contractManage',
    meta: {
      roles: ['SYS_CONTRACT_QUERY']
    },
    component: Layout,
    children: [
      {
        path: 'contract-bench',
        name: 'contractBench',
        meta: {
          roles: ['SYS_CONTRACT_QUERY'],
          title: '合同管理',
          icon: 'contract-manage',
          activeMenu: '/contract-manage/contract-bench/',
          componentName: 'ContractWorkbench',
          breadcrumb: [
            {
              name: '合同管理',
              path: '/contract-manage/contract-bench'
            }
          ]
        },
        component: ContractWorkbench
      },
      {
        path: 'edit-contract-workflow/:id',
        props: true,
        name: 'editContractWorkflow',
        meta: {
          title: '编辑合同',
          hidden: true,
          activeMenu: '/contract-manage/contract-bench',
          componentName: 'ContractWorkflowDetail',
          breadcrumb: [
            {
              name: '合同管理',
              path: '/contract-manage/contract-bench'
            },
            {
              name: '编辑合同',
              path: '/contract-manage/edit-contract-workflow/:id'
            }
          ]
        },
        component: ContractWorkflowDetail
      },
      {
        path: ':contractId/relate-assets',
        name: 'relateAssets',
        props: true,
        meta: {
          roles: [],
          title: '关联资产',
          hidden: true,
          activeMenu: '/contract-manage/contract-bench',
          componentName: 'RelateAssets',
          breadcrumb: [
            {
              name: '合同管理',
              path: '/contract-manage/contract-bench'
            },
            {
              name: '关联资产',
              path: '/contract-manage/:contractId/relate-assets'
            }
          ]
        },
        component: RelateAssets
      },
      {
        path: 'create-contract-workflow',
        name: 'createContractWorkflow',
        meta: {
          roles: ['SYS_CONTRACT_ADD'],
          title: '新建合同',
          hidden: true,
          activeMenu: '/contract-manage/contract-bench',
          componentName: 'ContractCreatePage',
          breadcrumb: [
            {
              name: '合同管理',
              path: '/contract-manage/contract-bench'
            },
            {
              name: '新建合同',
              path: '/contract-manage/create-contract-workflow'
            }
          ]
        },
        component: ContractCreatePage
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/contractManage.js